import { render, staticRenderFns } from "./video-conference-chat.html?vue&type=template&id=e7980d90&scoped=true&"
import script from "./video-conference-chat.js?vue&type=script&lang=js&"
export * from "./video-conference-chat.js?vue&type=script&lang=js&"
import style0 from "./video-conference-chat.scss?vue&type=style&index=0&id=e7980d90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7980d90",
  null
  
)

export default component.exports